import React from 'react';
import * as Styles from './ChatLog.style';

const ChatLog = ({ chatLog }) => {
  return (
    <div>
      {chatLog?.tickets &&
        chatLog?.tickets[0]?.ticket_log?.map((val, index) => (
          <Styles.NotificationContainer key={index}>
            <div className="action">
              <Styles.Action>{val?.action}</Styles.Action>
              <Styles.Date>{val?.action_en}</Styles.Date>
            </div>
            <Styles.Alert>{val?.date_ago_en}</Styles.Alert>
          </Styles.NotificationContainer>
        ))}
    </div>
  );
};
export default ChatLog;
